import { isDefined } from "@clipboard-health/util-ts";

import { WorkerInfoType } from "./api/useWorkplaceComments";

export function getPageCursor(cursorUrl: string): string | undefined {
  // eslint-disable-next-line prefer-destructuring
  const search = cursorUrl.split("?")[1];
  if (!isDefined(search)) {
    return undefined;
  }

  const searchParams = new URLSearchParams(search);

  return searchParams.get("page[cursor]") ?? undefined;
}

export function isViewerAuthor(params: { workerInfo: WorkerInfoType; viewerUserId: string }) {
  return params.workerInfo.isAuthor === true || params.workerInfo.id === params.viewerUserId;
}
